/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { bitcoinGetApiV3BitcoinStableMemorySizeInBytes } from "../../funcs/bitcoinGetApiV3BitcoinStableMemorySizeInBytes.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3BitcoinStableMemorySizeInBytesRequest$inboundSchema.optional(),
};

export const tool$bitcoinGetApiV3BitcoinStableMemorySizeInBytes: ToolDefinition<
  typeof args
> = {
  name: "bitcoin-get-api-v3-bitcoin-stable-memory-size-in-bytes",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] =
      await bitcoinGetApiV3BitcoinStableMemorySizeInBytes(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
